import React from "react";
import isAuthenticated from "./auth";
import { Router, Switch, Route, Redirect} from "react-router-dom";
import LoginContainer from "../login/containers/LoginContainer";
import DashboardContainer from "../dashboard/containers/DashboardContainer";
import UserListContainer from "../users/containers/UserListContainer";
import CreatePasswordContainer from "../users/containers/CreatePasswordContainer";
import RegisterGroupContainer from "../usersGroup/containers/RegisterGroupContainer";
import RegisterDepartment from "../department/containers/RegisterDepartmentContainer";
import CreateUserContainer from "../users/containers/CreateUserContainer";
import PowerBiContainer from "../powerBi/containers/PowerBiContainer";
import ListPowerBiContainer from "../powerBi/containers/ListPowerBiContainer";
import RegisterBiContainer from "../powerBi/containers/RegisterBiContainer";
import LogsContainer from "../logs/containers/LogsContainer"
import ForgotPassword from '../login/containers/ForgotPasswordContainer'

import * as history from "./history";

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      isAuthenticated() ? (
        <Component {...props} />
      ) : (
        <Redirect to={{ pathname: "/", state: { from: props.location } }} />
      )
    }
  />
);

const AppRouter = () => {
  return (

    <Router history={history}>
      <Switch>
        <Route exact path="/" component={LoginContainer} />
        <Route
          path="/create-password/:token"
          component={CreatePasswordContainer}
        />
        <Route 
          path="/forgot-password"
          component={ForgotPassword}
        />
        <PrivateRoute path="/user-list" component={UserListContainer} />
        <PrivateRoute path="/dashboard" component={DashboardContainer} />
        <PrivateRoute
          path="/register-group"
          component={RegisterGroupContainer}
        />
        <PrivateRoute
          path="/logs"
          component={LogsContainer}
        />
        <PrivateRoute
          path="/register-department"
          component={RegisterDepartment}
        />
        <PrivateRoute path="/user-create" component={CreateUserContainer} />
        <PrivateRoute path="/powerbi" exact component={ListPowerBiContainer} />
        <PrivateRoute path="/powerbi/:id" component={PowerBiContainer} />
        <PrivateRoute path="/register-bi" component={RegisterBiContainer} />

      </Switch>
    </Router>
  
  );
};

export default AppRouter;
